// REACT
import React, { RefObject, useRef, useContext, useEffect } from 'react'

// ESTILOS
import Style from './Location.module.css'

// IMAGENES
import Icon from 'Assets/General/pin.svg'
import MainContext from 'Context/MainContext'

// PROPIEDADES
interface ILocationProps {
	className?: string
}

// GLOBALES
const differedSrc: string =
	'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15427.366258919783!2d-91.5193939!3d14.8341475!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xb01217b25d480722!2sVilla%20de%20Don%20Andr%C3%A9s!5e0!3m2!1ses-419!2sgt!4v1592933223906!5m2!1ses-419!2sgt'

const Location: React.FC<ILocationProps> = (props: ILocationProps) => {
	// CONTEXTO
	const { footer } = useContext(MainContext).lang

	// REFERENCIAS
	const location: RefObject<HTMLDivElement> = useRef(null)
	const frame: RefObject<HTMLIFrameElement> = useRef(null)

	// MOSTRAR/OCULTAR FRAME
	const hideLocation = () => {
		if (frame.current) frame.current.src = ''
		if (location.current) location.current.style.transform = 'scale(0)'
	}

	const showLocation = () => {
		if (frame.current) frame.current.src = differedSrc
		if (location.current) location.current.style.transform = 'scale(1)'
	}

	// OCULTAR LOCATION
	useEffect(() => {
		// SELECCIONAR IFRAME
		const rangeContainer: HTMLDivElement = document.querySelector(
			`.${Style.iframe}`
		) as HTMLDivElement

		// EVENTO
		window.addEventListener('click', (ev: MouseEvent) => {
			// ELEMENTO
			const el: HTMLElement = ev.target as HTMLElement

			// VERIFICAR QUE NO SEA EL CONTAINER
			if (
				rangeContainer &&
				!rangeContainer.contains(el) &&
				!el.classList.contains('locationTrigger')
			)
				hideLocation()
		})
	}, [])

	return (
		<div className={`${Style.container} ${props.className}`}>
			<img
				className={`${Style.img} locationTrigger`}
				src={Icon}
				width='40px'
				alt='Icon'
				onClick={showLocation}
			/>
			<p onClick={showLocation} className='locationTrigger'>
				{footer.maps}
			</p>
			<div className={Style.containerMaps} ref={location}>
				<div>
					<iframe
						title='Map'
						className={Style.iframe}
						ref={frame}
						src=''
						width='350'
						height='275'
						style={{ border: '0' }}
						aria-hidden='false'
					/>
				</div>
			</div>
		</div>
	)
}

export default Location
